import { useTranslation } from "react-i18next";

import Cell from "../../components/common/AccordionTable/components/Cell";
import { DividerTableMenu } from "../../components/common/AccordionTable/components/DropdownTableMenu/components/DividerTableMenu";
import DropdownItem from "../../components/common/AccordionTable/components/DropdownTableMenu/components/DropdownItem";
import FlexWrapper from "../../components/common/AccordionTable/components/FlexWrapper";
import CountryFlag from "../../components/common/CountryFlag";

export const useDnsCheckAdapter = () => {
  const { t } = useTranslation();

  const headerData = ["DNS", t("global.status")];

  const renderRowContent = item => {
    return (
      <>
        <Cell>{item.ip}</Cell>
        <Cell>{item.leak ? t("dnsCheck.leak") : t("dnsCheck.secure")}</Cell>
      </>
    );
  };

  const renderHeaderTitle = item => item.ip;

  const renderDropdownContent = item => {
    return (
      <>
        <DropdownItem>
          <span>{headerData[1]} </span>
          {item.leak ? t("dnsCheck.leak") : t("dnsCheck.secure")}
        </DropdownItem>

        <DividerTableMenu />
      </>
    );
  };

  return {
    headerData,
    renderRowContent,
    renderHeaderTitle,
    renderDropdownContent,
  };
};
